import { render, staticRenderFns } from "./organ_location_auto.vue?vue&type=template&id=2b02ad9b"
import script from "./organ_location_auto.vue?vue&type=script&lang=js"
export * from "./organ_location_auto.vue?vue&type=script&lang=js"
import style0 from "./organ_location_auto.vue?vue&type=style&index=0&id=2b02ad9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports